export default __webpack_public_path__ + "static/media/Manageable.e7c770c7.svg";